import { PasswordInput as MantinePasswordInput } from '@mantine/core';
import { Eye, EyeOff } from 'lucide-react';

export const PasswordInput = MantinePasswordInput.extend({
	defaultProps: {
		autoComplete: 'new-password',
		visibilityToggleIcon: ({ reveal }) => (reveal ? <EyeOff /> : <Eye />),

		rightSectionPointerEvents: 'none',
		visibilityToggleButtonProps: {
			size: 'sm',
			variant: 'ghost-secondary',
			'data-test-id': 'password-visibility-toggle',
		},
	},
});
